import { useState } from 'react'

import useUpdateReviewRequestContact from '../../hooks/useUpdateReviewRequestFeedback'

const Feedback = ({ feedbackSlug, rating, requestSlug }) => {
  const [feedback, setFeedback] = useState('')

  const [updateReviewRequestContact, { isLoading, isSuccess }] =
    useUpdateReviewRequestContact(requestSlug, feedbackSlug)

  const handleChange = (event) => setFeedback(event.target.value)

  const handleSubmit = (event) => {
    event.preventDefault()

    updateReviewRequestContact({
      feedback,
    })
  }

  const hasPositiveRating = rating >= 4

  if (isSuccess) {
    return (
      <div className="py-8">
        <h6>Thank you for your feedback.</h6>
      </div>
    )
  }

  return (
    <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
      {hasPositiveRating ? (
        <h6 className="font-medium text-center">
          That&rsquo;s great to hear!
          <br />
          Please tell us more about your experience.
        </h6>
      ) : (
        <h6 className="font-medium text-center">
          We&rsquo;re sorry to hear we didn&rsquo;t get it right.
          <br />
          Please tell us what we could have done better.
        </h6>
      )}
      <textarea
        className="px-2 py-3 border-2 rounded"
        onChange={handleChange}
        rows={4}
        value={feedback}
      />
      <button
        className="bg-indigo-600 font-semibold text-white px-2 py-3 rounded"
        disabled={isLoading}
        type="submit">
        Send Feedback
      </button>
    </form>
  )
}

export default Feedback
